/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export enum InvoiceSection {
    COMPANY = 'COMPANY',
    COUNTERPARTY = 'COUNTERPARTY',
    DOCUMENT_DATA = 'DOCUMENT_DATA',
    PRODUCTS = 'PRODUCTS',
    REIMBURSEMENT = 'REIMBURSEMENT',
    SUMMARY = 'SUMMARY',
}
